import { CircularProgress } from '@mui/material'
import { useAtomValue } from 'jotai'
import { FC, useEffect, useRef } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { currentLocationChangeAtom } from '../../../../atoms'

// TODO: Streamline the logic in this component, it works but it's a bit convoluted.
/**
 * Component that handles redirection for the Address Scheduler when the atom state is not set correctly.
 */
export const AddressChangeRedirect: FC = () => {
  const navigate = useNavigate()
  const currentLocationChange = useAtomValue(currentLocationChangeAtom)

  // in strict mode it navigates twice, this ref is a workaround for dev.
  const alreadyNavigated = useRef(false)

  useEffect(() => {
    if (!currentLocationChange && !alreadyNavigated.current) {
      navigate('..', { replace: true })
      alreadyNavigated.current = true
    }
  }, [navigate, currentLocationChange])

  if (!currentLocationChange) {
    // Render a placeholder page before navigating away.
    return <CircularProgress />
  } else {
    // Otherwise, render the children components.
    return <Outlet />
  }
}
